import { render, staticRenderFns } from "./ContIndex.vue?vue&type=template&id=b4ed8d50&scoped=true"
import script from "./ContIndex.vue?vue&type=script&lang=js"
export * from "./ContIndex.vue?vue&type=script&lang=js"
import style0 from "./ContIndex.vue?vue&type=style&index=0&id=b4ed8d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed8d50",
  null
  
)

export default component.exports